import _ from 'lodash';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import classnames from 'classnames';
import { LabelChoice } from '@scale/shared/types/params/annotation';
import AttributeRadioTree from './AttributeRadioTree';
import HintTooltipIcon from '../../tasks/textcollection/HintTooltipIcon';

interface AttributeRadioInputProps {
  choice: LabelChoice;
  selectedChoice?: string;
  isReadOnly?: boolean;
  instructionItem?: string;
  legendColor?: string;
  handleSelect?: (choice: string) => void;
}

export default class AttributeRadioInput extends React.Component<AttributeRadioInputProps> {
  render() {
    const choice = this.props.choice;

    // Deal with nested choices
    if (!_.isString(choice) && choice.subchoices) {
      return <AttributeRadioTree tree={choice} />;
    }

    let choiceValue: string;
    let choiceDisplay: string;
    let choiceHint: string | undefined;
    if (_.isString(choice)) {
      choiceValue = choice;
      choiceDisplay = choice;
      choiceHint = undefined;
    } else {
      choiceValue = choice.choice;
      choiceDisplay = choice.display || choice.choice;
      choiceHint = choice.hint;
    }

    const className = classnames('radio-selector__choice', {
      'is-selected': this.props.selectedChoice === choiceValue,
      'is-readonly': this.props.isReadOnly,
    });

    const onClick = () => {
      if (this.props.handleSelect && !this.props.isReadOnly) {
        this.props.handleSelect(choiceValue);
      }
    };

    return (
      <div
        className={className}
        onClick={onClick}
        data-tip={this.props.instructionItem}
        data-for="label-description"
        data-place="left"
        data-multiline={true}
      >
        <div className="radio-selector__icon">
          <div />
        </div>
        <div className="radio-selector__label">
          {choiceDisplay}
          {choiceHint && <HintTooltipIcon key={choiceValue} hint={choiceHint} />}
          {this.props.legendColor ? (
            <span className="legend" style={{ background: this.props.legendColor }} />
          ) : null}
        </div>

        <ReactTooltip id="label-description" />

        <style jsx>{`
          .radio-selector__choice {
            padding: 4px;
            border-radius: 2px;

            display: flex;
            align-items: center;

            transition: all 0.2s;
            cursor: pointer !important;
          }

          .radio-selector__choice:hover {
            background: rgba(0, 0, 0, 0.05);
          }

          .radio-selector__icon {
            background: white;
            height: 16px;
            width: 16px;
            border-radius: 16px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.05);
            margin-right: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .is-readonly .radio-selector__icon {
            background: rgba(0, 0, 0, 0.1);
          }

          .radio-selector__choice:hover .radio-selector__icon > div {
            content: ' ';
            height: 10px;
            width: 10px;
            border-radius: 10px;
            background: rgba(0, 0, 0, 0.1);
          }

          .radio-selector__choice.is-selected .radio-selector__icon > div {
            content: ' ';
            height: 10px;
            width: 10px;
            border-radius: 10px;
            background: var(--color-primary);
          }

          .radio-selector__label {
            color: rgba(0, 0, 0, 0.7);
            display: flex;
            flex-direction: row;
          }

          .radio-selector__label .legend {
            margin-left: 4px;
            display: inline-block;
            height: 14px;
            width: 14px;
            border-radius: 2px;
          }
        `}</style>
      </div>
    );
  }
}
